import { render, staticRenderFns } from "./XEasyTable.vue?vue&type=template&id=2f462fa4&scoped=true"
import script from "./XEasyTable.vue?vue&type=script&lang=js"
export * from "./XEasyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f462fa4",
  null
  
)

export default component.exports